var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader',{attrs:{"is-loading":_vm.loading,"color":"primary"}},[_c('v-flex',[_c('v-alert',{attrs:{"value":_vm.invalidCallback,"type":"error"}},[_vm._v(" "+_vm._s(_vm.$t('authentication.error'))+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }